import './ShopeeCorrTab.css'

import {
  Alert,
  Button,
  Form,
  Input,
  Modal,
  Popconfirm,
  Select,
  Table,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import {
  getDingAllItems,
  getDingShopeeCorr,
  deleteDingShopeeCorrs,
  updateDingShopeeCorr,
} from '../../../actions/dingAction'

import { UploadOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { uploadJJRelatedData } from '../../../actions/orderProcessAction.js'

const ShopeeItemName = ({ value }) => (
  <span className='ant-form-text'>{value}</span>
)

const { Search } = Input

const ShopeeCorrTab = ({
  uploadJJRelatedData,
  corrs,
  corrtableloading,
  getDingShopeeCorr,
  getDingAllItems,
  updateDingShopeeCorr,
  deleteDingShopeeCorrs,
  dingItems,
}) => {
  useEffect(() => {
    getDingAllItems()
  }, [getDingAllItems])
  const [jjModalOpen, setJjModal] = useState(false)
  const [jjModalForm] = Form.useForm()

  const [searchText, setSearchText] = useState('')
  const [statusFilter, setStatusFilter] = useState('all')
  const [selectedMissingIds, setSelectedMissingIds] = useState([])
  const filterTextRef = useRef(null)
  const filteredCorrs = corrs.filter(
    (ob) =>
      (statusFilter === 'all' || ob.dingSyncStatus === statusFilter) &&
      ((ob.shopeeItemName[0] && ob.shopeeItemName[0].includes(searchText)) ||
        (ob.shopeeChoiceName[0] &&
          ob.shopeeChoiceName[0].includes(searchText)) ||
        (ob.dingItemId && ob.dingItemId.includes(searchText)) ||
        (ob.dingItemName && ob.dingItemName.includes(searchText)) ||
        (ob.packingName && ob.packingName.includes(searchText)) ||
        (ob.shopeeItemId && ob.shopeeItemId.includes(searchText)) ||
        (ob.shopeeChoiceId && ob.shopeeChoiceId.includes(searchText)))
  )
  const missingCount = corrs.filter(
    (corr) => corr.dingSyncStatus === 'missing'
  ).length
  const unavailableCount = corrs.filter(
    (corr) => corr.dingSyncStatus === 'unavailable'
  ).length

  const corrDataTable = [
    {
      title: '操作',
      width: '70px',
      fixed: 'left',
      align: 'center',
      render: (text, record, index) => (
        <Button
          onClick={() => {
            jjModalForm.setFieldsValue({
              shopeeItemName: record.shopeeItemName[0],
              id: record._id,
              shopeeChoiceName: record.shopeeChoiceName[0],
              dingItemId: record.dingItemId,
              dingItemName: record.dingItemName,
              packingName: record.packingName,
              shopeeItemId: record.shopeeItemId,
              shopeeChoiceId: record.shopeeChoiceId,
              label: record.label,
            })
            setJjModal(true)
          }}
          size='small'
          type='primary'
        >
          編輯
        </Button>
      ),
    },
    {
      title: '鼎新同步狀態',
      dataIndex: 'dingSyncStatus',
      width: '100px',
      fixed: 'left',
      render: (status, record) => {
        if (status === 'unavailable') {
          const references = record.giftEventReferences || []
          return (
            <Tooltip
              title={
                references.length
                  ? `仍被活動引用：${references
                      .map((reference) => reference.name)
                      .join('、')}`
                  : '可勾選後刪除'
              }
            >
              <Tag color='red'>連續 {record.dingSyncMissingCount} 次不存在</Tag>
            </Tooltip>
          )
        }
        if (status === 'missing') {
          return (
            <Tag color='orange'>觀察中 {record.dingSyncMissingCount}/10</Tag>
          )
        }
        return <Tag color='green'>鼎新現有</Tag>
      },
    },
    {
      title: '蝦皮商品名稱',
      dataIndex: 'shopeeItemName',
      width: '290px',
      render: (text, record, index) => (
        <Tooltip
          title={`商品編號：${record.shopeeItemId}。選項編號：${record.shopeeChoiceId}。${text[0]}`}
        >
          <div className='dot-dot-text'>
            <a
              target='_blank'
              rel='noopener noreferrer'
              href={`https://shopee.tw/product/18173562/${record.shopeeItemId}`}
            >
              {text[0]}
            </a>
          </div>
        </Tooltip>
      ),
    },
    {
      title: '蝦皮選項名稱',
      dataIndex: 'shopeeChoiceName',
      width: '320px',
      render: (text, record, index) => (
        <Tooltip title={text[0]}>
          <div className='dot-dot-text'>{text[0]}</div>
        </Tooltip>
      ),
    },
    {
      title: '鼎新商品編號',
      dataIndex: 'dingItemId',
      width: '160px',
    },
    {
      title: '鼎新商品名稱',
      dataIndex: 'dingItemName',
      width: '290px',
      render: (text, record, index) => (
        <Tooltip title={text}>
          <div className='dot-dot-text'>{text}</div>
        </Tooltip>
      ),
    },
    {
      title: '揀貨名稱',
      dataIndex: 'packingName',
      width: '1100px',
    },
  ]
  useEffect(() => {
    getDingShopeeCorr()
  }, [getDingShopeeCorr])

  const onCancelJjModal = () => {
    setJjModal(false)
  }

  const onSentJjModal = (values) => {
    updateDingShopeeCorr(values)
    setJjModal(false)
  }
  return (
    <div className='m-4 tab'>
      <Modal
        visible={jjModalOpen}
        onCancel={onCancelJjModal}
        title='修改蝦皮對應資料'
        centered
        width={750}
        footer={[
          <Button key='back' onClick={onCancelJjModal}>
            取消
          </Button>,
          <Button
            key='clearOne'
            type='primary'
            onClick={() => {
              jjModalForm
                .validateFields()
                .then((values) => {
                  let allvals = jjModalForm.getFieldsValue(true)
                  onSentJjModal({ ...allvals, ...values })
                  jjModalForm.resetFields()
                })
                .catch((info) => {
                  console.log('Validate Failed:', info)
                })
            }}
          >
            確認修改
          </Button>,
        ]}
      >
        <Form
          colon
          form={jjModalForm}
          initialValues={jjModalOpen}
          size='small'
          requiredMark={true}
        >
          <Form.Item label='蝦皮商品名稱' name='shopeeItemName'>
            <ShopeeItemName />
          </Form.Item>
          <Form.Item label='蝦皮選項名稱' name='shopeeChoiceName'>
            <ShopeeItemName />
          </Form.Item>
          <Form.Item label='鼎新商品' name='dingItemName'>
            <Select
              showSearch
              placeholder='輸入鼎新商品名稱或編號'
              options={dingItems.map((ob) => ({
                value: ob.a1name,
                key: ob.a1id,
                a1name: ob.a1name,
                label: `${ob.a1name} @${ob.a1id}`,
              }))}
              onSelect={(text, opt) => {
                jjModalForm.setFieldsValue({ dingItemId: opt.key })
              }}
              filterOption={(inputValue, option) =>
                option.a1name
                  .toLowerCase()
                  .includes(inputValue.toLowerCase()) ||
                option.key.toLowerCase().includes(inputValue.toLowerCase())
              }
            />
          </Form.Item>
          <Form.Item label='揀貨名稱' name='packingName'>
            <Input placeholder='撿貨用的名稱' />
          </Form.Item>
          <Form.Item label='產品標示' name='label'>
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
      <Upload
        className='mx-3'
        name='touch_whale_excel'
        customRequest={uploadJJRelatedData}
      >
        <Button icon={<UploadOutlined />}> 上傳 jj 相關資料</Button>
      </Upload>
      <Alert
        className='my-3'
        type={unavailableCount ? 'warning' : 'info'}
        showIcon
        message={`鼎新對應同步：觀察中 ${missingCount} 筆；連續 10 次不存在 ${unavailableCount} 筆`}
        description='只有通過完整性檢查的鼎新同步才會累加缺席次數。連續 10 次不存在後可在此勾選刪除；仍被贈品活動引用的資料會禁止刪除。'
      />
      <Select
        className='mx-3'
        style={{ width: 230 }}
        value={statusFilter}
        onChange={(value) => {
          setStatusFilter(value)
          setSelectedMissingIds([])
        }}
        options={[
          { value: 'all', label: '全部同步狀態' },
          { value: 'active', label: '鼎新現有' },
          { value: 'missing', label: '觀察中（1～9次不存在）' },
          { value: 'unavailable', label: '連續10次不存在' },
        ]}
      />
      <Popconfirm
        className='mx-3 mt-2'
        title={`確定刪除選取的 ${selectedMissingIds.length} 筆對應？`}
        okText='確認刪除'
        cancelText='取消'
        disabled={!selectedMissingIds.length}
        onConfirm={async () => {
          await deleteDingShopeeCorrs(selectedMissingIds)
          setSelectedMissingIds([])
        }}
      >
        <Button danger disabled={!selectedMissingIds.length}>
          刪除選取的不存在對應
        </Button>
      </Popconfirm>
      <Search
        placeholder='輸入以搜尋'
        className='my-3'
        ref={filterTextRef}
        onChange={(e) => {
          filterTextRef.current.value = e.target.value
          setTimeout(() => setSearchText(e.target.value), 0)
        }}
      />
      <Table
        loading={corrtableloading}
        size='small'
        hideSelectAll
        bordered
        columns={corrDataTable}
        dataSource={filteredCorrs}
        rowSelection={{
          selectedRowKeys: selectedMissingIds,
          onChange: setSelectedMissingIds,
          getCheckboxProps: (record) => ({
            disabled:
              record.dingSyncStatus !== 'unavailable' ||
              (record.giftEventReferences || []).length > 0,
          }),
        }}
        scroll={{
          x: '1000px',
          y: '1100px',
        }}
        pagination={{ pageSize: 12 }}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  corrs: state.ding.dingShopeeCorr,
  corrtableloading:
    state.orderProcess.correspondence.view.dataTableLoading ||
    state.ding.dingAllItems.loading,
  dingItems: state.ding.dingAllItems.data,
})

export default connect(mapStateToProps, {
  uploadJJRelatedData,
  getDingShopeeCorr,
  getDingAllItems,
  updateDingShopeeCorr,
  deleteDingShopeeCorrs,
})(ShopeeCorrTab)
